<template>
  <div class="ai-text" v-loading="control.aiMergedTextLoading">
    <configure-item label="AI 汇总解读">
      <div class="ai-text__content">
        <el-input
          v-model="draft"
          type="textarea"
          :rows="10"
          resize="vertical"
          placeholder="汇总解读由各图片组件的解读拼接生成"
        ></el-input>
        <div v-if="!hasMaterial" class="ai-text__tip">暂无可汇总的图片解读</div>
        <div class="ai-text__actions">
          <ai-action-button
            :disabled="!hasMaterial || control.aiMergedTextSaving"
            :loading="control.aiMergedTextSaving"
            @click="handleSave"
          >
            更新解读
          </ai-action-button>
        </div>
      </div>
    </configure-item>
  </div>
</template>

<script>
import AiActionButton from "./AiActionButton";

export default {
  name: "AiMergedText",
  inject: ["control"],
  components: { AiActionButton },
  data() {
    return {
      draft: "",
    };
  },
  computed: {
    mergedText() {
      return this.control.aiMergedText;
    },
    hasMaterial() {
      return Boolean(this.mergedText && this.mergedText.hasMaterial);
    },
  },
  watch: {
    mergedText: {
      immediate: true,
      handler(value) {
        this.draft = value && value.mergedText ? value.mergedText : "";
      },
    },
  },
  methods: {
    handleSave() {
      if (!this.hasMaterial || this.control.aiMergedTextSaving) return;
      this.control.saveMergedAiText(this.draft);
    },
  },
};
</script>

<style lang="less" scoped>
.ai-text {
  margin-top: 10px;
  border-top: 1px solid #ebeef5;

  &__content {
    width: 330px;
  }

  &__tip {
    margin-top: 6px;
    color: #909399;
    font-size: 12px;
    line-height: 18px;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
}
</style>
